// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import {Dictionary} from '../../../shared/models/dictionary.model';
import {IBaseType} from '../../../shared/enums/ibase-type.enum';

export interface IRegistrationStatusType {
    id: number;
    value: string;
    displayValue: string;
    description: string;
    sortOrder: number;
    active: boolean;
}

export class RegistrationStatusType implements IRegistrationStatusType, IBaseType {
    public id: number;
    public value: string;
    public displayValue: string;
    public description: string;
    public sortOrder: number;
    public active: boolean;

    /**
		Returns Active RegistrationStatusType
	**/
    get Active(): IRegistrationStatusType {
        return this.FromId(1);
    }
    /**
		Returns Suspended RegistrationStatusType
	**/
    get Suspended(): IRegistrationStatusType {
        return this.FromId(2);
    }
    /**
		Returns Cancelled RegistrationStatusType
	**/
    get Cancelled(): IRegistrationStatusType {
        return this.FromId(3);
    }
    /**
		Returns Renewed RegistrationStatusType
	**/
    get Renewed(): IRegistrationStatusType {
        return this.FromId(4);
    }
    get Duplicated(): IRegistrationStatusType {
        return this.FromId(5);
    }
    get Voided(): IRegistrationStatusType {
        return this.FromId(6);
    }
    get Revoked(): IRegistrationStatusType {
        return this.FromId(7);
    }
    get Updated(): IRegistrationStatusType {
        return this.FromId(8);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1', { id: 1, value: 'Active', displayValue: 'Active', description: 'Active', sortOrder: 999, active: true });
        this._dictionary.add('2', { id: 2, value: 'Suspended', displayValue: 'Suspended', description: 'Suspended', sortOrder: 999, active: true });
        this._dictionary.add('3', { id: 3, value: 'Canceled', displayValue: 'Canceled', description: 'Canceled', sortOrder: 999, active: true });
        this._dictionary.add('4', { id: 4, value: 'Renewed', displayValue: 'Renewed', description: 'Renewed', sortOrder: 999, active: true });
        this._dictionary.add('5', { id: 5, value: 'Duplicated', displayValue: 'Duplicated', description: 'Duplicated', sortOrder: 999, active: true });
        this._dictionary.add('6', { id: 6, value: 'Voided', displayValue: 'Voided', description: 'Voided', sortOrder: 999, active: true });
        this._dictionary.add('7', { id: 7, value: 'Revoked', displayValue: 'Revoked', description: 'Revoked', sortOrder: 999, active: true });
        this._dictionary.add('8', { id: 8, value: 'Updated', displayValue: 'Updated', description: 'Updated', sortOrder: 999, active: true });

    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): IRegistrationStatusType {
        return this._dictionary[id];
    }

    public FromValue(value: string): IRegistrationStatusType {
        var match = this._dictionary.getValues().filter(function(data) {
            return data.value == value;
        });

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): IRegistrationStatusType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): IRegistrationStatusType[] {
        return this.GetAll().filter(function(data) {
            return data.active;
        });
    }

    public Sort(primaryField, secondaryField, reverse): IRegistrationStatusType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = function(path, reverse, primer, then) {
        var get = function(obj, path) {
                if (path) {
                    path = path.split('.');
                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }
                    return obj[path[len]];
                }
                return obj;
            },
            prime = function(obj) {
                return primer ? primer(get(obj, path)) : get(obj, path);
            };

        return function(a, b) {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
